import { render, staticRenderFns } from "./EditRoleLoader.vue?vue&type=template&id=4e4d67fe"
import script from "./EditRoleLoader.vue?vue&type=script&lang=ts"
export * from "./EditRoleLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports